import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrudComponent } from './crud/crud.component';
import { ManageComponent } from './manage/manage.component';
import { FitnessLogsComponent } from './fitness-logs/fitness-logs.component';

const routes: Routes = [
  {
    path: "challenges/create",
    component: CrudComponent
  },
  {
    path: "challenges",
    component: ManageComponent
  },
  {
    path: "challenges/update/:id",
    component: CrudComponent
  },
  {
    path: "logs",
    component: FitnessLogsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PhysicalFitnessRoutingModule { }
